import CollectionContent from '../components/layout/Collection/CollectionContent';


function CollectionPage() {
  return (
    <section>
      <CollectionContent />
    </section>
  );
}

export default CollectionPage;